var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterNodeLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33336 6V11.2533C7.36003 11.4533 7.29336 11.6667 7.14003 11.8067C7.07835 11.8685 7.00509 11.9175 6.92444 11.951C6.84379 11.9844 6.75734 12.0016 6.67003 12.0016C6.58271 12.0016 6.49626 11.9844 6.41561 11.951C6.33496 11.9175 6.2617 11.8685 6.20003 11.8067L4.86003 10.4667C4.78732 10.3956 4.73203 10.3087 4.69849 10.2127C4.66495 10.1167 4.65407 10.0142 4.66669 9.91333V6H4.64669L0.806693 1.08C0.698432 0.94102 0.649582 0.764839 0.670818 0.589953C0.692054 0.415068 0.78165 0.255698 0.920026 0.146667C1.04669 0.0533334 1.18669 0 1.33336 0H10.6667C10.8134 0 10.9534 0.0533334 11.08 0.146667C11.2184 0.255698 11.308 0.415068 11.3292 0.589953C11.3505 0.764839 11.3016 0.94102 11.1934 1.08L7.35336 6H7.33336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNodeLabel);
export default __webpack_public_path__ + "static/media/filter-node-label.c1e6962c59732310670c74acff927c15.svg";
export { ForwardRef as ReactComponent };